import axios from "axios";
import Notification from "@/classes/component-classes/Notification";

export function useGetDocumentsList(id, route, store, shipments) {

    let mode = shipments.selectedShowShipmentsTab ? shipments.selectedShowShipmentsTab : route.params.mode

    axios.get('Shipments/documents', {

        params: {
            owner:  store.state.owner,
            shipmentId: id,
            mode: mode
        }
    }).then((response) => {

        store.state.hideLoadingSpinner = true;
        shipments.shipmentDocs = response.data

    }).catch(function (error) {

        store.state.hideLoadingSpinner = true;
        store.state.banners.error = new Notification(true, 'Could Not Retrieve Documents')

    });

    shipments.shipmentDocsDrawer = true;

}
